import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { toast } from "sonner";
import {
  Plug2, Loader2, MessageSquare, Sparkles, Workflow, Landmark, MapPin, Mail,
  Wifi, WifiOff, Settings2, AlertTriangle, ChevronRight, CheckCircle2, Clock,
} from "lucide-react";

// mapping de ícones do catálogo -> componentes Lucide
const ICON_MAP = {
  "message-square": MessageSquare,
  "sparkles": Sparkles,
  "workflow": Workflow,
  "landmark": Landmark,
  "map-pin": MapPin,
  "mail": Mail,
};

const STATUS_META = {
  not_configured: { label: "Não configurado", cls: "text-[#737373] border-[#3a3a3a] bg-[#0a0a0a]", icon: Settings2 },
  configured:     { label: "Configurado",     cls: "text-cyan-300 border-cyan-500/40 bg-cyan-500/10", icon: CheckCircle2 },
  connected:      { label: "Conectado",       cls: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10", icon: Wifi },
  disconnected:   { label: "Desconectado",    cls: "text-amber-300 border-amber-500/40 bg-amber-500/10", icon: WifiOff },
  error:          { label: "Erro",            cls: "text-red-300 border-red-500/40 bg-red-500/10", icon: AlertTriangle },
};

function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export default function IntegracoesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/integrations");
      setItems(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha ao carregar integrações");
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <Layout>
      <div className="mb-7">
        <div className="text-[11px] uppercase tracking-[0.2em] text-emerald-300">Administração · V2</div>
        <h1 className="font-display text-3xl sm:text-[34px] font-bold tracking-tight mt-1 flex items-center gap-2" data-testid="integracoes-title">
          <Plug2 size={26} className="text-emerald-400"/> Integrações
        </h1>
        <p className="text-[#A3A3A3] text-[13px] sm:text-sm mt-1.5 max-w-2xl">
          Conecte serviços externos ao sistema Forte Capital.
          Cada integração armazena credenciais criptografadas no servidor e nunca expõe chaves ao browser.
        </p>
      </div>

      {loading ? (
        <div className="fc-card p-10 text-center text-[#737373]" data-testid="loading">
          <Loader2 className="animate-spin mx-auto" size={20}/>
        </div>
      ) : (
        <div className="grid gap-3" data-testid="integrations-list">
          {items.map(it => {
            const Icon = ICON_MAP[it.icon] || Plug2;
            const st = STATUS_META[it.status] || STATUS_META.not_configured;
            const SIcon = st.icon;
            return (
              <Link
                key={it.code}
                to={`/integracoes/${it.code}`}
                className="fc-card p-4 flex items-start gap-4 hover:bg-[#0e0e0e] transition-colors"
                data-testid={`integ-${it.code}`}
              >
                <div className={`flex-shrink-0 w-11 h-11 rounded-md border flex items-center justify-center ${it.implemented ? "border-emerald-500/30 text-emerald-300 bg-emerald-500/5" : "border-[#262626] text-[#737373] bg-[#0a0a0a]"}`}>
                  <Icon size={20}/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="font-semibold text-[#E5E5E5] text-[15px]">{it.name}</div>
                    <span className={`text-[10px] px-2 py-0.5 rounded border inline-flex items-center gap-1 ${st.cls}`}>
                      <SIcon size={10}/> {st.label}
                    </span>
                    {!it.implemented && (
                      <span className="text-[10px] px-2 py-0.5 rounded border border-[#3a3a3a] text-[#A3A3A3]">Em breve</span>
                    )}
                  </div>
                  <div className="text-[12px] text-[#A3A3A3] mt-1 leading-snug">{it.description}</div>
                  <div className="flex flex-wrap gap-4 mt-2.5 text-[10.5px] text-[#737373]">
                    <span className="flex items-center gap-1">
                      <Clock size={10}/> Última sinc.: {fmtDate(it.last_sync_at)}
                    </span>
                    <span className="flex items-center gap-1">
                      Último teste: {fmtDate(it.last_test_at)}
                    </span>
                    {(it.error_logs?.length ?? 0) > 0 && (
                      <span className="flex items-center gap-1 text-red-300">
                        <AlertTriangle size={10}/> {it.error_logs.length} erro(s)
                      </span>
                    )}
                  </div>
                </div>
                <ChevronRight size={18} className="text-[#737373] mt-1"/>
              </Link>
            );
          })}
        </div>
      )}
    </Layout>
  );
}
